'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _immutable = require('immutable');

var immutable = _interopRequireWildcard(_immutable);

var _components = {
	_$Unknown: {}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Lookup = _wrapComponent('_$Unknown')(_react2['default'].createClass({
	propTypes: {
		// Data for Select2,
		dataSet: _react2['default'].PropTypes.array.isRequired,

		// If true apply the prop `errorClass`
		hasError: _react2['default'].PropTypes.bool,

		// Class to apply if hasError is true.
		errorClass: _react2['default'].PropTypes.string,

		// Function to call with currently selected elements
		onSelection: _react2['default'].PropTypes.func,

		// Allow multiple selections
		multiple: _react2['default'].PropTypes.bool,

		// Placeholder to display in select
		placeholder: _react2['default'].PropTypes.string,

		// inline style for select
		styleWidth: _react2['default'].PropTypes.string,

		// enable or disable the input
		enabled: _react2['default'].PropTypes.bool
	},

	getDefaultProps: function getDefaultProps() {
		return {
			hasError: false,
			errorClass: "has-error", // default to Bootstrap 3's error class
			multiple: false,
			placeholder: ' ',
			value: [],
			styleWidth: "100%",
			enabled: true,
			minLength: 0,
			allowClear: true,
			dataSet: []
		};
	},

	///////////////////////////////
	// Lifecycle
	///////////////////////////////
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (this._isDataUpdated(prevProps.dataSet)) {
			// "brute-force" new data into our Select2 widget since Select2 doesn't
			// have a method for changng data on already-existing widgets
			this.createSelect2();
		} else {
			// Change placeholder
			if (prevProps.placeholder !== this.props.placeholder) {
				this.setPlaceholderTo(this.getInputElem(), this.props.placeholder);
			}

			// Handle val prop
			/*var updateVal = false;
   // ...if length of old val prop and new val prop arrays are the same,
   //    we'll need to check the elements
   if (prevProps.value.length == this.props.value.length) {
   	$.each(prevProps.value, function (index, value) {
   		if (this.props.value[index] != value) {
   			updateVal = true;
   		}
   	}.bind(this));
   		} else {
   	updateVal = true;
   }
   // ...update our val if we need to
   if (updateVal) {
   		}*/
			var value = this.props.value instanceof immutable.Map ? this.props.value.toJS() : this.props.value;
			this.getInputElem().select2("val", value);
			// Enable/disable
			if (prevProps.enabled != this.props.enabled) {
				this.getInputElem().select2("enable", this.props.enabled);
			}
		}
	},

	componentDidMount: function componentDidMount() {
		// Set up Select2
		var $node = this.createSelect2();
	},

	componentWillUnmount: function componentWillUnmount() {
		$(_reactDom2['default'].findDOMNode(this.refs.input)).select2("destroy");
	},

	///////////////////////////////
	// Manipulate Select2
	///////////////////////////////
	setPlaceholderTo: function setPlaceholderTo($elem, placeholder) {
		if (!placeholder) {
			placeholder = "";
		}
		var currData = $elem.select2("data");

		// Set placeholder to new placeholder
		$elem.attr("placeholder", placeholder);

		// Now workaround the fact that Select2 doesn't pick up on this
		// ..First assign null
		$elem.select2("data", null);

		// ..Then assign dummy value in case that currData is null since
		//   that won't do anything.

		$elem.select2("data", {});

		// ..Then put original data back
		$elem.select2("data", currData);
	},

	getValue: function getValue() {
		var $node = this.getInputElem();
		return $node.data('value') !== null ? $node.data('value') : undefined;
	},

	createSelect2: function createSelect2() {
		var me = this;
		// Get inital value
		var val = null;
		var value = this.props.value instanceof immutable.Map ? this.props.value.toJS() : this.props.value;
		if (Object.prototype.toString.call(value) === '[object Array]') {
			if (value.length > 0) {
				val = this.props.multiple ? value : value[0];
			}
		} else {
			val = value;
		}

		var options = {
			data: this.props.dataSet,
			minimumInputLength: this.props.minLength,
			multiple: this.props.multiple,
			val: val,
			allowClear: this.props.allowClear
		};

		options.initSelection = function (element, callback) {
			var data = element.data('value');
			return callback(data);
		};

		options.query = function (query) {
			me.props.query(query.term, query.page).then(function (data) {
				query.callback(data);
			});
		};

		var $node = this.getInputElem();
		$node.val(val).select2(options).on("change", this.handleChange).on("select2-open", this.handleErrorState).select2("enable", this.props.enabled).select2("val", val);
		this.setPlaceholderTo($node, this.props.placeholder);
	},

	///////////////////////////////
	// Helpers
	///////////////////////////////
	handleErrorState: function handleErrorState() {
		var $dropNode = $('#select2-drop');
		var classNames = $dropNode[0].className.split(/\s+/);

		if (this.props.hasError) {
			var hasErrorClass = $.inArray(this.props.errorClass, classNames);

			if (hasErrorClass == -1) {
				$dropNode.addClass(this.props.errorClass);
			}
		} else {
			$dropNode.removeClass(this.props.errorClass);
		}
	},

	handleChange: function handleChange(e) {
		var value = immutable.fromJS(this.getValue());
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	},

	getInputElem: function getInputElem() {
		return $(_reactDom2['default'].findDOMNode(this.refs.input));
	},

	_isDataUpdated: function _isDataUpdated(oldData) {
		// TODO: More robust dataSet checker.  Need to recurse and
		// check all elements of data set.
		if (oldData.length != this.props.dataSet.length) {
			return true;
		}

		return false;
	},

	getError: function getError() {
		return this.props.error && this.props.error[0];
	},

	render: function render() {
		var style = { width: this.props.styleWidth };
		return _react2['default'].createElement(
			'div',
			{ className: this.getError() ? this.props.errorClass : "" },
			_react2['default'].createElement('input', { type: 'hidden', style: style, ref: 'input' }),
			this.getError() && _react2['default'].createElement(
				'div',
				null,
				this.getError()
			)
		);
	}
}));

module.exports = Lookup;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Form/Lookup.js
 ** module id = 502
 ** module chunks = 2
 **/